<template>
    <!--
          作者：luoyiming
          时间：2019-10-26
          描述：菜品管理-菜品添加
      -->
    <div class="product-add" v-loading="loading">
        <div style="display: flex;">
            <div class="lang-dialog">
                <div class="lang-select-language">
                    <label>{{$t('主语言选择')}}</label>
                    <el-select v-model="mainLanguage" :placeholder="$t('请选择主语言')" style="width: 60%"
                               @change="selectMainLanguage">
                        <el-option
                            v-for="item in translations"
                            :key="item.text"
                            :label="item.text"
                            :value="item.name">
                        </el-option>
                    </el-select>
                </div>
                <div ref="langdialog">
                    <Lang :langList="langList" :activeName="activeName" @active-name-changed="updateActiveName"
                          :translateFiled="translateFiled"></Lang>
                </div>
            </div>
            <div class="right-contianer">
                <!--form表单-->
                <el-form size="small" ref="form" :model="translations[activeName].form.model" label-width="100px"
                         v-if="!loading" style="flex: 5">
                    <!--基础信息-->
                    <NewBasic ref="newBasic" :activeName="activeName"
                              @active-name-changed="updateActiveName"
                              @translateLoading="handleTranslate"
                              @notifyLangList="handleLangList" @ready="onNewBasicReady"
                    ></NewBasic>
                    <!--高级设置-->
                    <el-collapse accordion>
                        <el-collapse-item class="custom-collapse-item">
                            <template slot="title">
                                <div class="title-box">
                                    <span class="title" style="margin-left: 7px">{{$t('高级设置')}}</span>
                                </div>
                            </template>
                            <AdSet :activeName="activeName"></AdSet>
                        </el-collapse-item>
                    </el-collapse>
                    <!--提交-->
                    <div class="common-button-wrapper">
                        <el-button size="small" type="info" @click="cancelFunc">{{$t('取消')}}</el-button>
                        <el-button size="small" type="primary" @click="onSubmit" :loading="save_loading"
                                   style="margin-right:10px;">{{$t('修改')}}
                        </el-button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import PorductApi from '@/api/product.js';
import NewBasic from './part/NewBasic.vue';
import AdSet from './part/Adset.vue';
import bus from '@/utils/eventBus.js';
import {getAbsolutePosition} from '@/utils/base.js';
import Lang from "./part/Lang";

export default {
    mounted() {
        if (localStorage.getItem("mainLanguage") == undefined || localStorage.getItem("mainLanguage") == null) {
            this.activeName = 'chinese';
            this.mainLanguage = 'chinese';
        } else {
            this.mainLanguage = localStorage.getItem("mainLanguage")
            this.activeName = this.mainLanguage
        }
        bus.$on('changeLangPosition', this.changeLangPosition)
    },

    components: {
        /*基础信息*/
        NewBasic,
        /*高级设置*/
        AdSet,
        Lang,
    },
    data() {
        return {
            langList: [],
            translateFiled: '',
            activeName: "chinese",
            mainLanguage: "",
            placeholder: null,
            translateLoading: false,
            translations: {
                chinese: {
                    text: '中文', translated: false, name: 'chinese', loading: false, form: {
                        model: {
                            app_id: 0,
                            product_id: 0,
                            /*菜品名称*/
                            product_name: '',
                            /*菜品分类*/
                            category_id: null,
                            ingredient: [],//菜品配料
                            product_ingredient: [],//菜品配料
                            /*菜品图片*/
                            image: [],
                            /*菜品卖点*/
                            selling_point: '',
                            /*规格类别,默认10单规格，20多规格*/
                            spec_type: 10,
                            /*库存计算方式,默认20付款减库存，10下单减库存*/
                            deduct_stock_type: 20,
                            /*检查用户等级*/
                            is_alone_grade: 0,
                            sku: [{
                                product_price: '',
                                stock_num: 9999,
                                product_weight: '',
                                cost_price: '',
                                bag_price: "",
                                app_id: 0
                            }],
                            tag: [],
                            product_tag: [],
                            product_attr: [],
                            product_feed: [],
                            /* 最小购买量 */
                            min_buy: 1,
                            /* 菜品单位 */
                            product_unit: '',
                            /* 属性*/
                            /*菜品详情内容*/
                            content: '',
                            /*菜品状态*/
                            product_status: 10,
                            /*初始销量*/
                            sales_initial: 0,
                            /*菜品排序，默认100*/
                            product_sort: 100,
                            /*限购数量*/
                            limit_num: 0,
                            special_id: 0,
                            /*是否开启积分赠送,默认1为开启，0为关闭*/
                            is_points_gift: 1,
                            is_agent: 0,
                            /*是否开启单独分销,默认0为关闭，1为开启*/
                            is_ind_agent: 0,
                            /*分销佣金类型,默认10为百分比，20为固定金额*/
                            agent_money_type: 10,
                            /*一级佣金*/
                            first_money: 0,
                            /*二级佣金*/
                            second_money: 0,
                            /*三级佣金*/
                            third_money: 0,
                            /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
                            is_enable_grade: 1,
                            /*等级金额类型,默认10为百分比，20为固定金额*/
                            alone_grade_type: 10,
                            taste: "",//口味
                            IsShowAICompletion: true,//A一键补全信息
                            selectedOptions: [], // 用于存储选中的选项
                        },
                        /*菜品分类*/
                        category: [],
                        feed: [],
                        special: [],
                        /*会员等级*/
                        gradeList: [],
                        /*规格数据*/
                        specData: [],
                        /*分销基础设置*/
                        basicSetting: {},
                        /*分销佣金设置*/
                        agentSetting: {},
                        sync: 1,
                        /*运费模板*/
                        delivery: [],
                    },
                },
                english: {
                    text: 'English', translated: false, name: 'english', loading: false, form: {
                        model: {
                            app_id: 0,
                            product_id: 0,
                            /*菜品名称*/
                            product_name: '',
                            /*菜品分类*/
                            category_id: null,
                            ingredient: [],//菜品配料
                            product_ingredient: [],//菜品配料
                            /*菜品图片*/
                            image: [],
                            /*菜品卖点*/
                            selling_point: '',
                            /*规格类别,默认10单规格，20多规格*/
                            spec_type: 10,
                            /*库存计算方式,默认20付款减库存，10下单减库存*/
                            deduct_stock_type: 20,
                            /*检查用户等级*/
                            is_alone_grade: 0,
                            sku: [{
                                product_price: '',
                                stock_num: 9999,
                                product_weight: '',
                                cost_price: '',
                                bag_price: ""
                            }],
                            tag: [],
                            product_tag: [],
                            product_attr: [],
                            product_feed: [],
                            /* 最小购买量 */
                            min_buy: 1,
                            /* 菜品单位 */
                            product_unit: '',
                            /* 属性*/
                            /*菜品详情内容*/
                            content: '',
                            /*菜品状态*/
                            product_status: 10,
                            /*初始销量*/
                            sales_initial: 0,
                            /*菜品排序，默认100*/
                            product_sort: 100,
                            /*限购数量*/
                            limit_num: 0,
                            special_id: 0,
                            /*是否开启积分赠送,默认1为开启，0为关闭*/
                            is_points_gift: 1,
                            is_agent: 0,
                            /*是否开启单独分销,默认0为关闭，1为开启*/
                            is_ind_agent: 0,
                            /*分销佣金类型,默认10为百分比，20为固定金额*/
                            agent_money_type: 10,
                            /*一级佣金*/
                            first_money: 0,
                            /*二级佣金*/
                            second_money: 0,
                            /*三级佣金*/
                            third_money: 0,
                            /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
                            is_enable_grade: 1,
                            /*等级金额类型,默认10为百分比，20为固定金额*/
                            alone_grade_type: 10,
                            taste: "",//口味
                            IsShowAICompletion: true,//A一键补全信息
                            selectedOptions: [], // 用于存储选中的选项
                        },
                        /*菜品分类*/
                        category: [],
                        feed: [],
                        special: [],
                        /*会员等级*/
                        gradeList: [],
                        /*规格数据*/
                        specData: [],
                        /*分销基础设置*/
                        basicSetting: {},
                        /*分销佣金设置*/
                        agentSetting: {},
                        sync: 1,
                        /*运费模板*/
                        delivery: [],
                    },
                },
                italian: {
                    text: 'Italiano', translated: false, name: 'italian', loading: false, form: {
                        model: {
                            app_id: 0,
                            product_id: 0,
                            /*菜品名称*/
                            product_name: '',
                            /*菜品分类*/
                            category_id: null,
                            ingredient: [],//菜品配料
                            product_ingredient: [],//菜品配料
                            /*菜品图片*/
                            image: [],
                            /*菜品卖点*/
                            selling_point: '',
                            /*规格类别,默认10单规格，20多规格*/
                            spec_type: 10,
                            /*库存计算方式,默认20付款减库存，10下单减库存*/
                            deduct_stock_type: 20,
                            /*检查用户等级*/
                            is_alone_grade: 0,
                            sku: [{
                                product_price: '',
                                stock_num: 9999,
                                product_weight: '',
                                cost_price: '',
                                bag_price: ""
                            }],
                            tag: [],
                            product_tag: [],
                            product_attr: [],
                            product_feed: [],
                            /* 最小购买量 */
                            min_buy: 1,
                            /* 菜品单位 */
                            product_unit: '',
                            /* 属性*/
                            /*菜品详情内容*/
                            content: '',
                            /*菜品状态*/
                            product_status: 10,
                            /*初始销量*/
                            sales_initial: 0,
                            /*菜品排序，默认100*/
                            product_sort: 100,
                            /*限购数量*/
                            limit_num: 0,
                            special_id: 0,
                            /*是否开启积分赠送,默认1为开启，0为关闭*/
                            is_points_gift: 1,
                            is_agent: 0,
                            /*是否开启单独分销,默认0为关闭，1为开启*/
                            is_ind_agent: 0,
                            /*分销佣金类型,默认10为百分比，20为固定金额*/
                            agent_money_type: 10,
                            /*一级佣金*/
                            first_money: 0,
                            /*二级佣金*/
                            second_money: 0,
                            /*三级佣金*/
                            third_money: 0,
                            /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
                            is_enable_grade: 1,
                            /*等级金额类型,默认10为百分比，20为固定金额*/
                            alone_grade_type: 10,
                            taste: "",//口味
                            IsShowAICompletion: true,//A一键补全信息
                            selectedOptions: [], // 用于存储选中的选项
                        },
                        /*菜品分类*/
                        category: [],
                        feed: [],
                        special: [],
                        /*会员等级*/
                        gradeList: [],
                        /*规格数据*/
                        specData: [],
                        /*分销基础设置*/
                        basicSetting: {},
                        /*分销佣金设置*/
                        agentSetting: {},
                        sync: 1,
                        /*运费模板*/
                        delivery: [],
                    },
                },
                german: {
                    text: 'Deutsch', translated: false, name: 'german', loading: false, form: {
                        model: {
                            app_id: 0,
                            product_id: 0,
                            /*菜品名称*/
                            product_name: '',
                            /*菜品分类*/
                            category_id: null,
                            ingredient: [],//菜品配料
                            product_ingredient: [],//菜品配料
                            /*菜品图片*/
                            image: [],
                            /*菜品卖点*/
                            selling_point: '',
                            /*规格类别,默认10单规格，20多规格*/
                            spec_type: 10,
                            /*库存计算方式,默认20付款减库存，10下单减库存*/
                            deduct_stock_type: 20,
                            /*检查用户等级*/
                            is_alone_grade: 0,
                            sku: [{
                                product_price: '',
                                stock_num: 9999,
                                product_weight: '',
                                cost_price: '',
                                bag_price: ""
                            }],
                            tag: [],
                            product_tag: [],
                            product_attr: [],
                            product_feed: [],
                            /* 最小购买量 */
                            min_buy: 1,
                            /* 菜品单位 */
                            product_unit: '',
                            /* 属性*/
                            /*菜品详情内容*/
                            content: '',
                            /*菜品状态*/
                            product_status: 10,
                            /*初始销量*/
                            sales_initial: 0,
                            /*菜品排序，默认100*/
                            product_sort: 100,
                            /*限购数量*/
                            limit_num: 0,
                            special_id: 0,
                            /*是否开启积分赠送,默认1为开启，0为关闭*/
                            is_points_gift: 1,
                            is_agent: 0,
                            /*是否开启单独分销,默认0为关闭，1为开启*/
                            is_ind_agent: 0,
                            /*分销佣金类型,默认10为百分比，20为固定金额*/
                            agent_money_type: 10,
                            /*一级佣金*/
                            first_money: 0,
                            /*二级佣金*/
                            second_money: 0,
                            /*三级佣金*/
                            third_money: 0,
                            /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
                            is_enable_grade: 1,
                            /*等级金额类型,默认10为百分比，20为固定金额*/
                            alone_grade_type: 10,
                            taste: "",//口味
                            IsShowAICompletion: true,//A一键补全信息
                            selectedOptions: [], // 用于存储选中的选项
                        },
                        /*菜品分类*/
                        category: [],
                        feed: [],
                        special: [],
                        /*会员等级*/
                        gradeList: [],
                        /*规格数据*/
                        specData: [],
                        /*分销基础设置*/
                        basicSetting: {},
                        /*分销佣金设置*/
                        agentSetting: {},
                        sync: 1,
                        /*运费模板*/
                        delivery: [],
                    },
                },
                spanish: {
                    text: 'Español', translated: false, name: 'spanish', loading: false, form: {
                        model: {
                            app_id: 0,
                            product_id: 0,
                            /*菜品名称*/
                            product_name: '',
                            /*菜品分类*/
                            category_id: null,
                            ingredient: [],//菜品配料
                            product_ingredient: [],//菜品配料
                            /*菜品图片*/
                            image: [],
                            /*菜品卖点*/
                            selling_point: '',
                            /*规格类别,默认10单规格，20多规格*/
                            spec_type: 10,
                            /*库存计算方式,默认20付款减库存，10下单减库存*/
                            deduct_stock_type: 20,
                            /*检查用户等级*/
                            is_alone_grade: 0,
                            sku: [{
                                product_price: '',
                                stock_num: 9999,
                                product_weight: '',
                                cost_price: '',
                                bag_price: ""
                            }],
                            tag: [],
                            product_tag: [],
                            product_attr: [],
                            product_feed: [],
                            /* 最小购买量 */
                            min_buy: 1,
                            /* 菜品单位 */
                            product_unit: '',
                            /* 属性*/
                            /*菜品详情内容*/
                            content: '',
                            /*菜品状态*/
                            product_status: 10,
                            /*初始销量*/
                            sales_initial: 0,
                            /*菜品排序，默认100*/
                            product_sort: 100,
                            /*限购数量*/
                            limit_num: 0,
                            special_id: 0,
                            /*是否开启积分赠送,默认1为开启，0为关闭*/
                            is_points_gift: 1,
                            is_agent: 0,
                            /*是否开启单独分销,默认0为关闭，1为开启*/
                            is_ind_agent: 0,
                            /*分销佣金类型,默认10为百分比，20为固定金额*/
                            agent_money_type: 10,
                            /*一级佣金*/
                            first_money: 0,
                            /*二级佣金*/
                            second_money: 0,
                            /*三级佣金*/
                            third_money: 0,
                            /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
                            is_enable_grade: 1,
                            /*等级金额类型,默认10为百分比，20为固定金额*/
                            alone_grade_type: 10,
                            taste: "",//口味
                            IsShowAICompletion: true,//A一键补全信息
                            selectedOptions: [], // 用于存储选中的选项
                        },
                        /*菜品分类*/
                        category: [],
                        feed: [],
                        special: [],
                        /*会员等级*/
                        gradeList: [],
                        /*规格数据*/
                        specData: [],
                        /*分销基础设置*/
                        basicSetting: {},
                        /*分销佣金设置*/
                        agentSetting: {},
                        sync: 1,
                        /*运费模板*/
                        delivery: [],
                    },
                },
                french: {
                    text: 'Français', translated: false, name: 'french', loading: false, form: {
                        model: {
                            app_id: 0,
                            product_id: 0,
                            /*菜品名称*/
                            product_name: '',
                            /*菜品分类*/
                            category_id: null,
                            ingredient: [],//菜品配料
                            product_ingredient: [],//菜品配料
                            /*菜品图片*/
                            image: [],
                            /*菜品卖点*/
                            selling_point: '',
                            /*规格类别,默认10单规格，20多规格*/
                            spec_type: 10,
                            /*库存计算方式,默认20付款减库存，10下单减库存*/
                            deduct_stock_type: 20,
                            /*检查用户等级*/
                            is_alone_grade: 0,
                            sku: [{
                                product_price: '',
                                stock_num: 9999,
                                product_weight: '',
                                cost_price: '',
                                bag_price: ""
                            }],
                            tag: [],
                            product_tag: [],
                            product_attr: [],
                            product_feed: [],
                            /* 最小购买量 */
                            min_buy: 1,
                            /* 菜品单位 */
                            product_unit: '',
                            /* 属性*/
                            /*菜品详情内容*/
                            content: '',
                            /*菜品状态*/
                            product_status: 10,
                            /*初始销量*/
                            sales_initial: 0,
                            /*菜品排序，默认100*/
                            product_sort: 100,
                            /*限购数量*/
                            limit_num: 0,
                            special_id: 0,
                            /*是否开启积分赠送,默认1为开启，0为关闭*/
                            is_points_gift: 1,
                            is_agent: 0,
                            /*是否开启单独分销,默认0为关闭，1为开启*/
                            is_ind_agent: 0,
                            /*分销佣金类型,默认10为百分比，20为固定金额*/
                            agent_money_type: 10,
                            /*一级佣金*/
                            first_money: 0,
                            /*二级佣金*/
                            second_money: 0,
                            /*三级佣金*/
                            third_money: 0,
                            /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
                            is_enable_grade: 1,
                            /*等级金额类型,默认10为百分比，20为固定金额*/
                            alone_grade_type: 10,
                            taste: "",//口味
                            IsShowAICompletion: true,//A一键补全信息
                            selectedOptions: [], // 用于存储选中的选项
                        },
                        /*菜品分类*/
                        category: [],
                        feed: [],
                        special: [],
                        /*会员等级*/
                        gradeList: [],
                        /*规格数据*/
                        specData: [],
                        /*分销基础设置*/
                        basicSetting: {},
                        /*分销佣金设置*/
                        agentSetting: {},
                        sync: 1,
                        /*运费模板*/
                        delivery: [],
                    },
                },
                croatia: {
                    text: 'Hrvatska', translated: false, name: 'croatia', loading: false, form: {
                        model: {
                            app_id: 0,
                            product_id: 0,
                            /*菜品名称*/
                            product_name: '',
                            /*菜品分类*/
                            category_id: null,
                            ingredient: [],//菜品配料
                            product_ingredient: [],//菜品配料
                            /*菜品图片*/
                            image: [],
                            /*菜品卖点*/
                            selling_point: '',
                            /*规格类别,默认10单规格，20多规格*/
                            spec_type: 10,
                            /*库存计算方式,默认20付款减库存，10下单减库存*/
                            deduct_stock_type: 20,
                            /*检查用户等级*/
                            is_alone_grade: 0,
                            sku: [{
                                product_price: '',
                                stock_num: 9999,
                                product_weight: '',
                                cost_price: '',
                                bag_price: ""
                            }],
                            tag: [],
                            product_tag: [],
                            product_attr: [],
                            product_feed: [],
                            /* 最小购买量 */
                            min_buy: 1,
                            /* 菜品单位 */
                            product_unit: '',
                            /* 属性*/
                            /*菜品详情内容*/
                            content: '',
                            /*菜品状态*/
                            product_status: 10,
                            /*初始销量*/
                            sales_initial: 0,
                            /*菜品排序，默认100*/
                            product_sort: 100,
                            /*限购数量*/
                            limit_num: 0,
                            special_id: 0,
                            /*是否开启积分赠送,默认1为开启，0为关闭*/
                            is_points_gift: 1,
                            is_agent: 0,
                            /*是否开启单独分销,默认0为关闭，1为开启*/
                            is_ind_agent: 0,
                            /*分销佣金类型,默认10为百分比，20为固定金额*/
                            agent_money_type: 10,
                            /*一级佣金*/
                            first_money: 0,
                            /*二级佣金*/
                            second_money: 0,
                            /*三级佣金*/
                            third_money: 0,
                            /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
                            is_enable_grade: 1,
                            /*等级金额类型,默认10为百分比，20为固定金额*/
                            alone_grade_type: 10,
                            taste: "",//口味
                            IsShowAICompletion: true,//A一键补全信息
                            selectedOptions: [], // 用于存储选中的选项
                        },
                        /*菜品分类*/
                        category: [],
                        feed: [],
                        special: [],
                        /*会员等级*/
                        gradeList: [],
                        /*规格数据*/
                        specData: [],
                        /*分销基础设置*/
                        basicSetting: {},
                        /*分销佣金设置*/
                        agentSetting: {},
                        sync: 1,
                        /*运费模板*/
                        delivery: [],
                    },
                },
                slovenia: {
                    text: 'Slovenščina', translated: false, name: 'slovenia', loading: false, form: {
                        model: {
                            app_id: 0,
                            product_id: 0,
                            /*菜品名称*/
                            product_name: '',
                            /*菜品分类*/
                            category_id: null,
                            ingredient: [],//菜品配料
                            product_ingredient: [],//菜品配料
                            /*菜品图片*/
                            image: [],
                            /*菜品卖点*/
                            selling_point: '',
                            /*规格类别,默认10单规格，20多规格*/
                            spec_type: 10,
                            /*库存计算方式,默认20付款减库存，10下单减库存*/
                            deduct_stock_type: 20,
                            /*检查用户等级*/
                            is_alone_grade: 0,
                            sku: [{
                                product_price: '',
                                stock_num: 9999,
                                product_weight: '',
                                cost_price: '',
                                bag_price: ""
                            }],
                            tag: [],
                            product_tag: [],
                            product_attr: [],
                            product_feed: [],
                            /* 最小购买量 */
                            min_buy: 1,
                            /* 菜品单位 */
                            product_unit: '',
                            /* 属性*/
                            /*菜品详情内容*/
                            content: '',
                            /*菜品状态*/
                            product_status: 10,
                            /*初始销量*/
                            sales_initial: 0,
                            /*菜品排序，默认100*/
                            product_sort: 100,
                            /*限购数量*/
                            limit_num: 0,
                            special_id: 0,
                            /*是否开启积分赠送,默认1为开启，0为关闭*/
                            is_points_gift: 1,
                            is_agent: 0,
                            /*是否开启单独分销,默认0为关闭，1为开启*/
                            is_ind_agent: 0,
                            /*分销佣金类型,默认10为百分比，20为固定金额*/
                            agent_money_type: 10,
                            /*一级佣金*/
                            first_money: 0,
                            /*二级佣金*/
                            second_money: 0,
                            /*三级佣金*/
                            third_money: 0,
                            /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
                            is_enable_grade: 1,
                            /*等级金额类型,默认10为百分比，20为固定金额*/
                            alone_grade_type: 10,
                            taste: "",//口味
                            IsShowAICompletion: true,//A一键补全信息
                            selectedOptions: [], // 用于存储选中的选项
                        },
                        /*菜品分类*/
                        category: [],
                        feed: [],
                        special: [],
                        /*会员等级*/
                        gradeList: [],
                        /*规格数据*/
                        specData: [],
                        /*分销基础设置*/
                        basicSetting: {},
                        /*分销佣金设置*/
                        agentSetting: {},
                        sync: 1,
                        /*运费模板*/
                        delivery: [],
                    },
                },
                hungarian: {
                    text: 'Magyar', translated: false, name: 'hungarian', loading: false, form: {
                        model: {
                            app_id: 0,
                            product_id: 0,
                            /*菜品名称*/
                            product_name: '',
                            /*菜品分类*/
                            category_id: null,
                            ingredient: [],//菜品配料
                            product_ingredient: [],//菜品配料
                            /*菜品图片*/
                            image: [],
                            /*菜品卖点*/
                            selling_point: '',
                            /*规格类别,默认10单规格，20多规格*/
                            spec_type: 10,
                            /*库存计算方式,默认20付款减库存，10下单减库存*/
                            deduct_stock_type: 20,
                            /*检查用户等级*/
                            is_alone_grade: 0,
                            sku: [{
                                product_price: '',
                                stock_num: 9999,
                                product_weight: '',
                                cost_price: '',
                                bag_price: ""
                            }],
                            tag: [],
                            product_tag: [],
                            product_attr: [],
                            product_feed: [],
                            /* 最小购买量 */
                            min_buy: 1,
                            /* 菜品单位 */
                            product_unit: '',
                            /* 属性*/
                            /*菜品详情内容*/
                            content: '',
                            /*菜品状态*/
                            product_status: 10,
                            /*初始销量*/
                            sales_initial: 0,
                            /*菜品排序，默认100*/
                            product_sort: 100,
                            /*限购数量*/
                            limit_num: 0,
                            special_id: 0,
                            /*是否开启积分赠送,默认1为开启，0为关闭*/
                            is_points_gift: 1,
                            is_agent: 0,
                            /*是否开启单独分销,默认0为关闭，1为开启*/
                            is_ind_agent: 0,
                            /*分销佣金类型,默认10为百分比，20为固定金额*/
                            agent_money_type: 10,
                            /*一级佣金*/
                            first_money: 0,
                            /*二级佣金*/
                            second_money: 0,
                            /*三级佣金*/
                            third_money: 0,
                            /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
                            is_enable_grade: 1,
                            /*等级金额类型,默认10为百分比，20为固定金额*/
                            alone_grade_type: 10,
                            taste: "",//口味
                            IsShowAICompletion: true,//A一键补全信息
                            selectedOptions: [], // 用于存储选中的选项
                        },
                        /*菜品分类*/
                        category: [],
                        feed: [],
                        special: [],
                        /*会员等级*/
                        gradeList: [],
                        /*规格数据*/
                        specData: [],
                        /*分销基础设置*/
                        basicSetting: {},
                        /*分销佣金设置*/
                        agentSetting: {},
                        sync: 1,
                        /*运费模板*/
                        delivery: [],
                    },
                },
                cрпскијезик: {
                    text: 'Cрпскијезик', translated: false, name: 'cрпскијезик', loading: false, form: {
                        model: {
                            app_id: 0,
                            product_id: 0,
                            /*菜品名称*/
                            product_name: '',
                            /*菜品分类*/
                            category_id: null,
                            ingredient: [],//菜品配料
                            product_ingredient: [],//菜品配料
                            /*菜品图片*/
                            image: [],
                            /*菜品卖点*/
                            selling_point: '',
                            /*规格类别,默认10单规格，20多规格*/
                            spec_type: 10,
                            /*库存计算方式,默认20付款减库存，10下单减库存*/
                            deduct_stock_type: 20,
                            /*检查用户等级*/
                            is_alone_grade: 0,
                            sku: [{
                                product_price: '',
                                stock_num: 9999,
                                product_weight: '',
                                cost_price: '',
                                bag_price: ""
                            }],
                            tag: [],
                            product_tag: [],
                            product_attr: [],
                            product_feed: [],
                            /* 最小购买量 */
                            min_buy: 1,
                            /* 菜品单位 */
                            product_unit: '',
                            /* 属性*/
                            /*菜品详情内容*/
                            content: '',
                            /*菜品状态*/
                            product_status: 10,
                            /*初始销量*/
                            sales_initial: 0,
                            /*菜品排序，默认100*/
                            product_sort: 100,
                            /*限购数量*/
                            limit_num: 0,
                            special_id: 0,
                            /*是否开启积分赠送,默认1为开启，0为关闭*/
                            is_points_gift: 1,
                            is_agent: 0,
                            /*是否开启单独分销,默认0为关闭，1为开启*/
                            is_ind_agent: 0,
                            /*分销佣金类型,默认10为百分比，20为固定金额*/
                            agent_money_type: 10,
                            /*一级佣金*/
                            first_money: 0,
                            /*二级佣金*/
                            second_money: 0,
                            /*三级佣金*/
                            third_money: 0,
                            /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
                            is_enable_grade: 1,
                            /*等级金额类型,默认10为百分比，20为固定金额*/
                            alone_grade_type: 10,
                            taste: "",//口味
                            IsShowAICompletion: true,//A一键补全信息
                            selectedOptions: [], // 用于存储选中的选项
                        },
                        /*菜品分类*/
                        category: [],
                        feed: [],
                        special: [],
                        /*会员等级*/
                        gradeList: [],
                        /*规格数据*/
                        specData: [],
                        /*分销基础设置*/
                        basicSetting: {},
                        /*分销佣金设置*/
                        agentSetting: {},
                        sync: 1,
                        /*运费模板*/
                        delivery: [],
                    },
                },
            },
            /* 审核状态*/
            old_audit: 20,
            /*菜品ID*/
            product_id: 0,
            app_id: 0,
            /*判断是编辑*/
            scene: 'edit',
            /*是否正在加载*/
            loading: true,
            /*是否正在提交保存*/
            save_loading: false,
            /*form表单数据*/
            form: {
                /*应用ID*/
                app_id: 0,
                /*菜品ID*/
                product_id: 0,
                model: {},
                /*菜品分类*/
                category: [],
                /*会员等级*/
                gradeList: [],
                feed: [],
                special: [],
                /*规格数据*/
                specData: null,
                /*是否锁住*/
                isSpecLocked: false,
                /*分销基础设置*/
                basicSetting: {},
                /*分销佣金设置*/
                agentSetting: {}
            },
            /*模型数据*/
            model: {
                /*应用ID*/
                app_id: 0,
                /*菜品ID*/
                product_id: 0,
                /*菜品名称*/
                product_name: '',
                /*菜品分类*/
                category_id: null,
                ingredient: [],//菜品配料
                /*菜品图片*/
                image: [],
                /*菜品卖点*/
                selling_point: '',
                /*规格类别,默认10单规格，20多规格*/
                spec_type: 10,
                /*库存计算方式,默认20付款减库存，10下单减库存*/
                deduct_stock_type: 20,
                /*检查用户等级*/
                is_alone_grade: 0,
                /*单规格*/
                sku: [{
                    product_price: '',
                    stock_num: '',
                    product_weight: '',
                    cost_price: ''
                }],
                product_attr: [],
                product_feed: [],
                tag: [],
                product_tag: [],
                /* 最小购买量 */
                min_buy: 1,
                /* 菜品单位 */
                product_unit: '',
                /*菜品详情内容*/
                content: '',
                /*菜品状态*/
                product_status: 10,
                /*初始销量*/
                sales_initial: 0,
                /*菜品排序，默认100*/
                product_sort: 100,
                /*限购数量*/
                limit_num: 0,
                special_id: 0,
                /*是否开启积分赠送,默认1为开启，0为关闭*/
                is_points_gift: 1,
                is_agent: 0,
                /*是否开启单独分销,默认0为关闭，1为开启*/
                is_ind_agent: 0,
                /*分销佣金类型,默认10为百分比，20为固定金额*/
                agent_money_type: 10,
                /*一级佣金*/
                first_money: 0,
                /*二级佣金*/
                second_money: 0,
                /*三级佣金*/
                third_money: 0,
                /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
                is_enable_grade: 1,
                /*等级金额类型,默认10为百分比，20为固定金额*/
                alone_grade_type: 10,
                taste: "",//口味
                IsShowAICompletion: false,//A一键补全信息
            },
            langObj: null,
        };
    },
    provide: function () {
        return {
            translations: this.translations,
        };
    },
    created() {
        /*获取列表*/
        this.product_id = this.$route.query.product_id;
        this.scene = this.$route.query.scene;
        this.getData();
    },
    methods: {
        onNewBasicReady() {
            this.selectMainLanguage(this.mainLanguage);
        },
        changeLangPosition(scrollTop) {
            let el = this.$refs.langdialog
            let coordinate = getAbsolutePosition(el)
            var dialog = this.$el.querySelector('.lang-dialog');
            if (coordinate.top <= 106) {
                if (!this.placeholder) {
                    this.placeholder = document.createElement('div');
                    this.placeholder.style.width = dialog.offsetWidth + 'px';
                    this.placeholder.style.height = dialog.offsetHeight + 'px';
                    this.placeholder.style.flexShrink = 0;
                    dialog.parentNode.insertBefore(this.placeholder, dialog);
                }
                if (dialog) {
                    dialog.classList.add('lang-dialog-flex');
                }
            } else {
                if (dialog) {
                    dialog.classList.remove('lang-dialog-flex');
                }
                if (this.placeholder) {
                    this.placeholder.parentNode.removeChild(this.placeholder);
                    this.placeholder = null;
                }
            }
        },
        //多语言组件的列表信息
        handleLangList(langList, translateFiled) {
            this.langList = langList;
            this.translateFiled = translateFiled
        },
        selectMainLanguage(value) {
            localStorage.setItem("mainLanguage", value)
            this.activeName = value
            this.langList = this.$refs.newBasic.composeLangStatus(0);
        },
        handleTranslate(status) {
            this.translateLoading = status;
        },
        updateActiveName(newName) {
            this.activeName = newName;
        },
        /**
         * 获取基础数据
         */
        getData: function () {
            let self = this;
            PorductApi.storeGetEditData({
                    product_id: self.product_id,
                    scene: self.scene
                },
                true
            )
                .then(res => {
                    self.loading = false;
                    if (res.data.model.alone_grade_equity != null && typeof res.data.model.alone_grade_equity !=
                        'undefined') {
                        let equitys = res.data.model.alone_grade_equity;
                        res.data.gradeList.forEach(item => {
                            item.product_equity = equitys[item.grade_id];
                        });
                    }

                    Object.assign(self.form, res.data);
                    for (let key in this.translations) {
                        // 使用深拷贝来创建独立的数据对象
                        let dataCopy = JSON.parse(JSON.stringify(self.form));
                        this.$set(this.translations[key], 'form', dataCopy);
                        this.$set(this.translations[key].form.model, 'product_status', this.translations[key].form.model.product_status.value);
                    }
                    self.app_id = self.form.model.app_id
                    let mainLanguage = localStorage.getItem('mainLanguage');
                    if (res.data.model.lang != null) {
                        let jsonString = res.data.model.lang.product_info
                        this.langObj = JSON.parse(jsonString)
                        console.log('this.langObj', this.langObj)
                        for (let key in this.translations) {
                            if (this.langObj[key].hasOwnProperty('model')) {
                                // model 存在，你可以在这里进行你的操作
                                Object.assign(this.translations[key].form.model, this.langObj[key].model);
                            } else {
                                // model 不存在
                                Object.assign(this.translations[key].form.model, this.langObj[key]);
                            }
                            this.$set(this.translations[key].form.model, 'category_id', res.data.model.category_id);
                            this.$set(this.translations[key].form.model, 'image', res.data.model.image);
                            this.$set(this.translations[key].form.model, 'sku', res.data.model.sku);
                        }
                    } else {
                        for (let key in this.translations) {
                            if (mainLanguage != key) {
                                this.$set(this.translations[key].form.model, 'product_name', "");
                                this.$set(this.translations[key].form.model, 'selling_point', "");
                                this.$set(this.translations[key].form.model, 'taste', "");
                                this.$set(this.translations[key].form.model, 'content', "");
                                this.$set(this.translations[key].form.model, 'ingredient', []);
                                this.$set(this.translations[key].form.model, 'category_id', res.data.model.category_id);
                                this.$set(this.translations[key].form.model, 'image', res.data.model.image);
                            }
                        }
                    }
                })
                .catch(error => {
                    self.loading = false;
                });
        },

        requestServerTranslate(word, language, filedName) {
            let translateData = {
                "word": word,
                "language": language,
                "from_language": localStorage.getItem("mainLanguage"),
            }
            PorductApi.translate_word(translateData, true).then(res => {
                this.translateLoading = false
                if (res.code == 1) {
                    let translatedRes = res.data.response
                    //拿到大模型返回的翻译数据
                    console.log("翻译菜品名称返回来的数据", translatedRes)
                    this.translations[language].form.model[filedName] = translatedRes
                }
            }).catch(error => {
                console.log("翻译出错了")
            });
        },
        /*转JSON字符串*/
        convertJson(list) {
            let obj = {};
            list.forEach(item => {
                obj[item.grade_id] = item.product_equity;
            });
            return JSON.stringify(obj);
        },

        resetSubmitFormData(originalData) {
            let newFormModel = {
                product_name: originalData.product_name,
                ingredient: originalData.ingredient,
                selling_point: originalData.selling_point,
                product_tag: originalData.product_tag,
                content: originalData.content,
                taste: originalData.taste,
            }
            return newFormModel
        },
        /*提交*/
        onSubmit: function () {
            if (this.translateLoading) {
                this.$message({
                    message: this.$t('正在完成翻译，请稍后操作') ,
                    type: 'warning'
                });
                return
            }
            let self = this;
            self.$refs.form.validate(valid => {
                if (valid) {
                    let mainLanguage = localStorage.getItem("mainLanguage")
                    let params = self.translations[mainLanguage].form.model;
                    delete params.lang
                    delete params.alone_grade_equity
                    params.ingredient = self.form.model.ingredient
                    self.save_loading = true;
                    self.app_id = self.app_id;
                    params.product_lang = JSON.stringify({
                        english: this.resetSubmitFormData(this.translations.english.form.model),
                        italian: this.resetSubmitFormData(this.translations.italian.form.model),
                        german: this.resetSubmitFormData(this.translations.german.form.model),
                        spanish: this.resetSubmitFormData(this.translations.spanish.form.model),
                        french: this.resetSubmitFormData(this.translations.french.form.model),
                        chinese: this.resetSubmitFormData(this.translations.chinese.form.model),
                        croatia: this.resetSubmitFormData(this.translations.croatia.form.model),
                        slovenia: this.resetSubmitFormData(this.translations.slovenia.form.model),
                        hungarian: this.resetSubmitFormData(this.translations.hungarian.form.model),
                        cрпскијезик: this.resetSubmitFormData(this.translations.cрпскијезик.form.model),
                    })
                    const tagArray = Object.values(params.tag);
                    let tag = []
                    tagArray.forEach(item => {
                        tag.push({
                            name: item.name,
                            sort: 1,
                            tag_id: 0,
                            app_id: self.app_id
                        });
                    })
                    params.tag = tag
                    console.log('提交参数:', params)
                    PorductApi.storeEditProduct({
                        product_id: self.product_id,
                        params: JSON.stringify(params)
                    }, true)
                        .then(data => {
                            self.save_loading = false;
                            self.$message({
                                message:self.$t('保存成功') ,
                                type: 'success'
                            });
                            self.cancelFunc();
                        })
                        .catch(error => {
                            self.save_loading = false;
                        });
                }
            });
        },

        /*保存为草稿*/
        Draft() {
            let self = this;
            self.form.model.product_status = 30;
            self.onSubmit();
        },

        /*取消*/
        cancelFunc() {
            this.$router.push({
                path: '/buildstore/index/index',
                query: {
                    step: 8,
                    tab: 1
                }
            });
        }
    },
    beforeDestroy() {
        bus.$off('changeLangPosition');
    },
};
</script>

<style lang="scss" scoped>
.product-add {
    padding-bottom: 50px;
}

.mb50 {
    margin-bottom: 50px;
}

.big-text {
    font-size: 20px;
}

.lang-dialog {
    width: 180px;
}

.right-contianer {
    flex: 5;
}

.lang-select-language {
    margin-bottom: 20px;
}

.lang-dialog-flex {
    position: fixed;
    top: 80px;
    left: 132px;

    z-index: 5;
}

.title-box {
    position: relative;
    height: 30px;
    padding-left: 20px;
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 12px;
}

.title:before {
    position: absolute;
    content: "";
    width: 4px;
    height: 14px;
    left: 5px;
    top: 25px;
    transform: translateY(-50%);
}

.title:before {
    background: #3a8ee6;
}
</style>



// WEBPACK FOOTER //
// src/views/buildstore/goods/store/product/edit.vue